import { render, staticRenderFns } from "./VLoadingButton.vue?vue&type=template&id=149c6e4a&"
import script from "./VLoadingButton.vue?vue&type=script&lang=js&"
export * from "./VLoadingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports